import {
  safeDeepDelete,
} from '../../../../util/util';

// @TODO this needs knowledge of wrapups and the entire tree for selecting off/on

/**
 * Select the clicked item
 * @param  {object} tree  [getRows tree]
 * @param  {array} keys   [applicable keys]
 * @param  {bool} checked [if action was a check or uncheck]
 * @return {object}       [modified tree]
 */
export default function selectAction(tree, keys, check) {
  if (check) {
    // Bunch of pass by reference magic here
    let temp = tree;
    keys.forEach((itemKey) => {
      if (temp[itemKey]) {
        temp = temp[itemKey];
      } else {
        temp[itemKey] = {};
        temp = temp[itemKey];
      }
    });
  } else {
    let unselectAll = false;
    if (keys[keys.length - 1] === 'all') {
      unselectAll = true;
      keys.pop(); // We don't want to care about all if it's the key, just kill everything
    }
    // Iterate over for side effect to gain tree deletion
    keys.slice().reverse().some((itemKey, idx, arr) =>
      safeDeepDelete(
        [...arr.slice(idx + 1).reverse(), itemKey],
        tree,
        arr.length === 1 || unselectAll
      )
    );
  }
  return tree;
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/refineColumns/children/events/selectAction.js
 **/